// removed by extract-text-webpack-plugin
module.exports = {"pdf-page-wrap":"pdfPage__pdf-page-wrap___27RYn","pdf-page":"pdfPage__pdf-page___12ppb"};


//////////////////
// WEBPACK FOOTER
// ./src/pdf/pdfPage.scss
// module id = 1255
// module chunks = 0